const API_VERSION = 'v1';
const apiUrl = process.env.REACT_APP_API_URL;
export const apiRoot = `${apiUrl}/api/${API_VERSION}/`;

const callApi = async (endpoint, headers = {}, method = 'GET', body = null) => {
  const options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...headers,
    },
    method,
  };

  if (body !== null) {
    options.body = JSON.stringify(body);
  }

  const url = apiRoot + endpoint;

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      const errorData = await response.json();
      const errorMessage =
        errorData && errorData.error
          ? errorData.error.message
          : errorData.errors
          ? errorData.message
          : 'Something went wrong!!!';
      if (response.status === 401 && errorMessage === 'Session expired') {
        handleSessionExpiry();
      } else {
        throw new Error(errorMessage);
      }
    }
    if (response.status === 204) {
      return null;
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

const handleSessionExpiry = () => {
  localStorage.clear();
  window.location.href = '/login';
};

export default callApi;
